import axios from 'axios';
import { GetServerSideProps } from 'next';
import Error from 'next/error';
import Link from 'next/link';

interface GhostArticle {
    title: string;
    html: string;
    feature_image: string;
    feature_image_alt: string;
    feature_image_caption: string;
    published_at: string;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    try {
        if (!params?.slug) {
            return { notFound: true };
        }

        const articleSlug = Array.isArray(params.slug) ? params.slug.join('/') : params.slug;
        const url = `https://blog.krush.chat/ghost/api/v3/content/posts/slug/${articleSlug}/?key=764a0819807fb3775d083c6f97`;

        const response = await axios.get(url);
        const article = response.data.posts[0];

        if (!article) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                article
            }
            };
        } catch (error) {
            return {
            notFound: true
            };
        }
  }

  const Blog = ({ article }: { article: GhostArticle }) => {
    // Remove useState and useEffect hooks since we're getting data from props
    if (!article) {
        return <Error statusCode={404} />;
    }

    return (
        <div className="blog-container relative min-h-screen flex flex-col items-center">
            <div className="blog-content-wrapper flex-1 pb-16 max-w-3xl w-full mx-auto">
                <div className="mb-4 text-sm hover:underline">
                    <Link href="/blog" className="text-brand hover:text-brand-dark">
                        Blog
                    </Link>
                </div>
                <h1>{article.title}</h1>
                <div className="blog-meta">
                    <time dateTime={article.published_at}>
                        {new Date(article.published_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}
                    </time>
                </div>
                {article.feature_image && (
                    <figure className="feature-image-container">
                        <img
                            src={article.feature_image}
                            alt={article.feature_image_alt || article.title}
                            className="feature-image"
                        />
                        {article.feature_image_caption && (
                            <figcaption dangerouslySetInnerHTML={{ __html: article.feature_image_caption }} />
                        )}
                    </figure>
                )}
                <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: article.html }}
                />
            </div>

            <div className="sticky cursor-pointer bottom-0 w-full bg-black  text-white text-center">
                <div className='w-full bg-brand bg-opacity-70 hover:bg-opacity-90 p-3'>
                    <Link href="/" className="hover:text-gray-300 font-semibold">
                        Welcome to Krush! ❤️ Chat with hundreds of beautiful models with the ultimate uncensored AI.
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Blog;